// extracted by mini-css-extract-plugin
export default {"floatycircle":"floaty-module--floatycircle--lnef5","awslogo":"floaty-module--awslogo--27PtS","cov1":"floaty-module--cov1--3IrSC","cov2":"floaty-module--cov2--2K7IN"};